import PubSub from 'pubsub-js';
import { TOPIC_IDS, MEDIA_QUERIES } from '@/js/constants';

// Plugins
import DisableScroll from '@/js/plugins/DisableScroll';
import SmoothScroll from './plugins/SmoothScroll';

// Modules
import Carousel from './modules/Carousel';
import DetailsAccordion from './modules/DetailsAccordion';
import { Menu } from './modules/Menu';
import { MegaMenu } from './modules/MegaMenu';
import { MenuLinkHandler } from './modules/MenuLinkHandler';
import { ScrollSpy } from './modules/ScrollSpy';
import Form from './modules/Form';
import handleStickyHeaderScroll from './modules/HeaderScroll';
import Filter from './modules/Filter';
import FilterSubmit from './modules/FilterSubmit';
import ShareLinks from './modules/ShareLinks';
import SelectLanguage from '@/js/modules/SelectLanguage';
import TextCards from './modules/TextCards';
import Showcase from './modules/Showcase';
import Highlights from './modules/Highlights';
import Numbers from './modules/Numbers';
import Modal from './modules/Modal';
import ModalText from './modules/ModalText';
import { GDPR } from '@/js/modules/GDPR';
import { InputButton } from '@/js/modules/InputButton';
import { BlockSkip } from '@/js/modules/BlockSkip';

export type Modules = {
  [key: string]: any;
};

class App {
  globals: Modules;

  constructor() {
    this.globals = {};

    this.bind();

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', () => {
        this.initialize();
      });
    } else {
      this.initialize();
    }
  }

  private bind() {
    this.initialize = this.initialize.bind(this);
    this.addGlobals = this.addGlobals.bind(this);
    this.addGlobal = this.addGlobal.bind(this);
  }

  initialize() {
    this.globals = {
      disableScroll: new DisableScroll(),
      smoothScroll: new SmoothScroll(),
      carousel: new Carousel('.js-carousel'),
      menu: new Menu('.js-menu'),
      menuLinkHandler: new MenuLinkHandler('.js-menu'),
      megaMenu: new MegaMenu('.js-mega-menu'),
      detailsAccordionMenu: new DetailsAccordion('.js-details-accordion[data-target="menu"]', {
        breakpoints: {
          [MEDIA_QUERIES.MOBILE]: true,
          [MEDIA_QUERIES.DESKTOP]: false,
        },
      }),
      // directory用のアコーディオンを追加
      detailsAccordionDirectory: new DetailsAccordion('.js-details-accordion[data-target="directory"]', {
        breakpoints: {
          [MEDIA_QUERIES.MOBILE]: true,
          [MEDIA_QUERIES.DESKTOP]: true, // PCでも有効
        },
      }),
      scrollSpy: new ScrollSpy('.js-scrollspy'),
      selectLanguage: SelectLanguage('.js-language-select--foundation'),
      filter: new Filter('.js-filter'),
      filterfSubmit: new FilterSubmit('.js-filter-content'),
      shareLinks: ShareLinks(),
      textCards: new TextCards('.js-text-cards'),
      showcase: new Showcase('.js-showcase'),
      highlights: new Highlights('.js-highlights'),
      form: new Form('.js-form'),
      numbers: new Numbers('.js-numbers'),
      modal: Modal(),
      modalText: ModalText(".js-modal-text"),
      gdpr: new GDPR('.js-gdpr', { fade: true }),
      inputButton: new InputButton('.js-input-button'),
      blockSkip: new BlockSkip('.js-block-skip', {
        skipSelector: '[data-skip-target]', // このセレクタの対象が存在しない場合は、main直下の最初のフォーカス可能要素にスキップされる
      }),
      // pagetop: new Pagetop('.js-pagetop'),
    };

    // スクロールイベント header追従用
    window.addEventListener('scroll', handleStickyHeaderScroll);

    // document.body.classList.add('is-content-ready');
    PubSub.publish(TOPIC_IDS.APP_READY);
  }

  addGlobals(instances: Modules = {}) {
    if (!(instances instanceof Object)) {
      console.error('[App] Error: instances must be Object');
      return;
    }
    Object.keys(instances).forEach((name) => {
      this.addGlobal(name, instances[name]);
    });
  }

  addGlobal(name: string, instance: any) {
    this.globals[name] = instance;
  }
}

const app = new App();
export default app;
